import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { m as n } from "motion/react";
import { useAnimateFadeIn as c } from "../../../animation/animation.js";
import s from "./welcome-text.module.less.js";
const h = ({ textStart: t, textEnd: i, logoUrl: a }) => {
  const m = c({ whileInView: !0, easing: "easeInOut" });
  return /* @__PURE__ */ e("section", { className: s.wrapper, children: /* @__PURE__ */ e(n.div, { ...m, className: "max-width centered padded-sides", children: /* @__PURE__ */ r("div", { className: s.innerWrapper, children: [
    a && /* @__PURE__ */ e("img", { className: s.topLogo, src: a ?? void 0, alt: "Preem logo" }),
    /* @__PURE__ */ r("h1", { className: a ? "mb-0" : "", children: [
      /* @__PURE__ */ e("span", { className: s.textStart, children: t }),
      " ",
      i
    ] })
  ] }) }) });
};
export {
  h as WelcomeText,
  h as default
};
